<template lang="pug">
    v-card.py-2
        v-card-text.pa-2
            vue-markdown.py-0.content-text-ellipsis(v-if="currentReference.display_type=='TEXT'" :source='String(localContentMessage)')
            div.d-flex.justify-center.align-center(v-else-if="currentReference.display_type=='IMAGE'&& currentReference.doc_image_urls.length > 0")
                v-img(:src="currentReference.doc_image_urls[0].doc_image_url" :aspect-ratio="16/9" error max-width='100' )
            //- p(v-else) {{currentReference.filename}}
            //- div(class='font_arial' v-html='errorMessage')
        //- v-card-actions.px-2.pb-5
        //-     v-row
        //-         v-col.pl-2(cols='12')
        //-             v-btn(v-hide-element='false' :ripple='false' @click='onConfirm' width='100%' height='40' color='success' depressed='depressed' dark='dark') {{$t('GENERAL.CLOSE')}}
</template>

<script>
	import Vue from 'vue';
    import VueMarkdown from 'vue-markdown-v2';

	export default Vue.extend({
        props: {
            contentMessage: {
                type: String,
                required: true,
            },
            currentReference:{
                type: Object,
                required: true,
            },
        },
        created() {
            this.currentType = this.currentReference.display_type
            this.localContentMessage = this.currentReference.cut_content
        },
        components: {
            VueMarkdown
        },
        data() {
            return {
                localContentMessage: '',
                currentType:'IMAGE'
            };
        },
        methods: {

		},
        watch: {
        }
	});
</script>